import React, { useEffect, useState, useRef } from 'react';
import Img from '../assets/svgs/menu-bar.svg';
import '../components-css/blogs.scss';
import ArrowIcon from '../assets/svgs/Group 3.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { BASE_URL } from '../config';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Blogs = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [blogsData, setBlogsData] = useState(props?.blogsData || null);
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const animationIdRef = useRef(null);
  const scrollPositionRef = useRef(0);

  // Format the date for display
  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      AOS.init({ disable: 'mobile' });
    } else {
      AOS.init({ duration: 1000, once: true, offset: 50 });
    }
  }, []);

  useEffect(() => {
    if (!blogsData) {
      axios.get(`${BASE_URL}/GetBlogs`)
        .then((response) => setBlogsData(response.data.data))
        .catch((error) => console.error('Error fetching blogs:', error));
    }
  }, [blogsData]);

  // Custom smooth continuous scroll animation
  useEffect(() => {
    // ❌ Disable auto scroll on mobile
    if (window.innerWidth < 768) return;

    const container = scrollContainerRef.current;
    if (!container || !blogsData?.blog_list?.length) return;

    const scroll = () => {
      if (!isPaused) {
        scrollPositionRef.current += 1;

        const maxScroll = container.scrollHeight / 2;
        if (scrollPositionRef.current >= maxScroll) {
          scrollPositionRef.current = 0;
        }

        container.scrollTop = scrollPositionRef.current;
      }

      animationIdRef.current = requestAnimationFrame(scroll);
    };

    animationIdRef.current = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationIdRef.current);
    };
  }, [isPaused, blogsData]);


  // Immediate stop on hover
  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  // Immediate start on mouse leave
  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  // Ensure data exists before accessing properties
  if (blogsData) {
    const firstBlog = blogsData?.first_blog?.[0] || {};
    const formattedDate = formatDate(firstBlog.created_at);

    // Duplicate blog list for infinite scroll effect
    const duplicatedBlogs = [...blogsData.blog_list, ...blogsData.blog_list];

    return (
      <div className="blogs-main-container">
        {/* Left Section */}
        <div className="left-section" data-aos="fade-right">
          <p>{formattedDate}</p>
          <h2>{firstBlog.title}</h2>
          <img
            onClick={() => navigate(`/blog/${firstBlog.slug}`)}
            className='image'
            src={firstBlog.file_path + firstBlog.thumbnail}
            alt="Blog Thumbnail"
          />
          <Link
            to="/blogs"
            className="portfolio-page"
            onClick={() => {
              sessionStorage.setItem("homeScrollPosition", window.scrollY);
            }}
          >            <div className="button">
              <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>BLOGS</span>
                <span className='img'>
                  <img src={isHovered ? GradientArrowIcon : ArrowIcon} alt="Arrow Icon" />
                </span>
              </button>
            </div>
          </Link>
        </div>

        {/* Right Slider Section */}
        <div
          className="right-slider-section custom-scroll-container"
          ref={scrollContainerRef}
          data-aos="fade-left"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            height: window.innerWidth < 768 ? 'auto' : '540px',
            overflow: window.innerWidth < 768 ? 'visible' : 'hidden',
            position: 'relative'
          }}
        >
          <div className="scroll-content">
            {duplicatedBlogs.map((blog, index) => (
              <div
                onClick={() => {
                  sessionStorage.setItem("homeScrollPosition", window.scrollY);
                  navigate(`/blog/${blog.slug}`);
                }}
                className='slide'
                key={`${blog.slug}-${index}`}
                style={{ marginBottom: '20px' }}
              >
                <img
                  className='blog-image'
                  src={blog.file_path + blog.thumbnail}
                  alt="Blog Image"
                />
                <div className="heading">
                  <div className="img">
                    <img src={Img} alt="Menu Icon" />
                  </div>
                  <h3>{blog.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Blogs;